var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 17.4c.8.8 2 .8 2.8 0s.8-2 0-2.8L12.8 10l4.6-4.6c.8-.8.8-2 0-2.8s-2-.8-2.8 0L10 7.2 5.4 2.6c-.8-.8-2-.8-2.8 0s-.8 2 0 2.8L7.2 10l-4.6 4.6c-.8.8-.8 2 0 2.8s2 .8 2.8 0l4.6-4.6z"
  })));
};
export default SvgClose;